import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

import Visa from '../../../../svg/visa.svg';
import Master from '../../../../svg/master_card.svg';
import Telegram from '../../../../svg/telegram.svg';
import Whatsapp from '../../../../svg/whatsapp.svg';
import Skype from '../../../../svg/skype.svg';
import Viber from '../../../../svg/viber.svg';
// import Star from '../../../../svg/star_shaddow.svg';
import Star from '../../../../svg/star_footer.svg';
import Tiktok from '../../../../svg/tik-tok.svg';
import Instagram from '../../../../svg/instagram.svg';
import Facebook from '../../../../svg/facebook.svg';

const FooterMiddle = ({ contactsData }) => {
  const langToggle = useLanguage;

  return (
    <div className="footer-middle">
      <div className="footer-middle__messengers-wrapper">
        <p className="footer-middle__messengers-marker">
          {langToggle('Напишіть нам:', 'Напишите нам:')}
        </p>
        <ul className="footer-middle__messengers">
          {contactsData.Messengers.map((item, index) => {
            const icon =
              item.title === 'telegram' ? (
                <Telegram className="footer-middle__messengers-link__icon" />
              ) : item.title === 'whatsapp' ? (
                <Whatsapp className="footer-middle__messengers-link__icon" />
              ) : item.title === 'skype' ? (
                <Skype className="footer-middle__messengers-link__icon" />
              ) : item.title === 'viber' ? (
                <Viber className="footer-middle__messengers-link__icon" />
              ) : null;
            return (
              <li className="footer-middle__messengers-item" key={index}>
                <a
                  href={item.link}
                  className="footer-middle__messengers-link"
                  target="blank"
                >
                  <span className="footer-middle__messengers-link__title">
                    {item.title}
                  </span>
                  <span className="footer-middle__messengers-link__icon-wrapper">
                    <Star className="footer-middle__messengers-link__star" />
                    {icon}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="footer-middle__socials-wrapper">
        <p className="footer-middle__socials-marker">
          {langToggle('Стежте за нами:', 'Следите за нами:')}
        </p>
        <ul className="footer-middle__socials">
          {contactsData.Socials.map((item, index) => {
            const icon =
              item.title === 'Tik Tok' ? (
                <Tiktok className="footer-middle__socials-link__icon" />
              ) : item.title === 'Instagram' ? (
                <Instagram className="footer-middle__socials-link__icon" />
              ) : item.title === 'Facebook' ? (
                <Facebook className="footer-middle__socials-link__icon" />
              ) : null;

            return (
              <li className="footer-middle__socials-item" key={index}>
                <a
                  href={item.link}
                  className="footer-middle__socials-link"
                  target="blank"
                >
                  <span className="footer-middle__socials-link__title">
                    {item.title}
                  </span>
                  <span className="footer-middle__socials-link__icon-wrapper">
                    <Star className="footer-middle__socials-link__star" />
                    {icon}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="footer-middle__partners">
        <a
          href="https://www.visa.com.ua/"
          target="blank"
          className="footer-middle__partners-logo"
        >
          <Visa className="footer-middle__partners-logo__icon" />
        </a>
        <a
          href="https://www.mastercard.ua/"
          target="blank"
          className="footer-middle__partners-logo"
        >
          <Master className="footer-middle__partners-logo__icon" />
        </a>
      </div>
    </div>
  );
};

FooterMiddle.propTypes = {
  contactsData: PropTypes.object,
};

export default FooterMiddle;
